import React from 'react'
import {
  Segment,
  Divider,
  Grid,
  Header,
  Button,
  Icon,
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'

const EmptySelectionPlaceholder = ({onPickSelectionMode}) => (
  <div>
    <p>
      You currently have no learning outcomes and no topics selected.
      Browse or search the curriculum to add some.
    </p>
    <Segment placeholder>
      <Grid columns={2} stackable textAlign='center'>
        <Divider vertical>Or</Divider>
        <Grid.Row verticalAlign='middle'>
          <Grid.Column>
            <Header icon>
              <Icon name='world'/>
              Browse Knowledge Areas
            </Header>
            <Button color='orange' as={Link} to='/areas' onClick={onPickSelectionMode}>Browse</Button>
          </Grid.Column>
          <Grid.Column>
            <Header icon>
              <Icon name='search'/>
              Search Outcomes
            </Header>
            <Button color='orange' as={Link} to='/search' onClick={onPickSelectionMode}>Search</Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
)

export default EmptySelectionPlaceholder;